import axios from "axios";
// import store from "@/store";

const axiosMemod = axios.create({
    baseURL: process.env.VUE_APP_MEMOD_API_URL
});

axiosMemod.interceptors.response.use(response => {
    // Do something with response data
    return response;
}, error => {
    // Only report errors on production
    if (process.env.NODE_ENV !== "development") {
        Sentry.captureException(error);
    }
    // Do something with response error
    return Promise.reject(error);
});


window.axiosMemod = axiosMemod;
export default axiosMemod;
